import { Business } from '@material-ui/icons';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { TextBoxIcon } from 'shared/icons';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import {
  useHasOnboardingPackets,
  useHasPendingOnboardingPackets,
} from 'shared/modules/onboarding-packets/data/OnboardingPacketsAPI';
import { CarrierWebviewHeader } from '../CarrierWebviewHeader';
import { CarrierProfileWebviewHeader } from './CarrierProfileWebviewHeader';
import { CarrierProfilePageItem } from './ProfileWebviewPage';

export function CarrierWebviewNavigationMenuPage() {
  const { hasOnboardingPackets } = useHasOnboardingPackets();
  const hasPendingOnboardingPackets = useHasPendingOnboardingPackets();

  useDocumentTitle('Carrier Profile');

  return (
    <CarrierWebviewHeader>
      <Box
        width="100%"
        maxWidth="832px"
        padding="small"
        marginLeft="auto"
        marginRight="auto"
      >
        <Stack space="small">
          <CarrierProfileWebviewHeader />

          <Stack space="xxsmall">
            <CarrierProfilePageItem
              icon={
                <Business fontSize="small" htmlColor={ColorDynamic.Dark300} />
              }
              label="Profile"
              route="/profile/details"
            />

            {hasOnboardingPackets && (
              <CarrierProfilePageItem
                icon={
                  <TextBoxIcon
                    fontSize="small"
                    htmlColor={ColorDynamic.Dark300}
                  />
                }
                label="Onboarding Packets"
                route="/onboarding-packets"
                shouldShowToDoTag={hasPendingOnboardingPackets}
              />
            )}
          </Stack>
        </Stack>
      </Box>
    </CarrierWebviewHeader>
  );
}
